import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { MobileTabBar, TabItem } from "./MobileTabBar";
import { Home, Briefcase, TrendingUp, BookOpen, LogOut, Loader2, FolderOpen } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";
import { useAuth } from "@/hooks/useAuth";
import { useVagasNotifications } from "@/hooks/useVagasNotifications";
import { useLogout } from "@/hooks/useLogout";
import { Button } from "@/components/ui/button";

export function AlunoLayout() {
  const { user, loading: authLoading } = useAuth();
  const { profile, isLoading: profileLoading } = useProfile();
  const navigate = useNavigate();
  const vagasBadge = useVagasNotifications();
  const handleLogout = useLogout("aluno");

  if (authLoading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/aluno/login" replace />;
  }

  if (profile && !profile.terms_accepted_at) {
    return <Navigate to="/aluno/termos" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Top bar with logout */}
      <header className="sticky top-0 z-40 bg-card/80 backdrop-blur-sm border-b border-border px-4 py-2 flex items-center justify-end">
        <Button variant="ghost" size="sm" onClick={handleLogout} className="text-muted-foreground hover:text-destructive gap-1.5">
          <LogOut className="w-4 h-4" />
          <span className="text-xs">Sair</span>
        </Button>
      </header>

      <main className="pb-20">
        <Outlet />
      </main>
      
      <MobileTabBar>
        <TabItem to="/aluno" icon={Home} label="Home" />
        <TabItem to="/aluno/vagas" icon={Briefcase} label="Vagas" badge={vagasBadge} />
        <TabItem to="/aluno/carreira" icon={TrendingUp} label="Carreira" />
        <TabItem to="/aluno/experiencia" icon={FolderOpen} label="Experiência" />
        <TabItem to="/aluno/aprender" icon={BookOpen} label="Aprender" />
      </MobileTabBar>
    </div>
  );
}
